import Icon from '../components/Icon.vue'

Icon.register({"comment-dots":{"width":512,"height":512,"paths":[{"d":"M256 32C114.6 32 0 125.1 0 240 0 289.6 21.4 335 57 370.7 44.5 421.1 2.7 466 2.2 466.5 0 468.8-0.6 472.2 0.7 475.2S4.8 480 8 480C74.3 480 124 448.2 148.6 428.6 181.3 440.9 217.6 448 256 448 397.4 448 512 354.9 512 240S397.4 32 256 32zM128 272C110.3 272 96 257.7 96 240S110.3 208 128 208 160 222.3 160 240 145.7 272 128 272zM256 272C238.3 272 224 257.7 224 240S238.3 208 256 208 288 222.3 288 240 273.7 272 256 272zM384 272C366.3 272 352 257.7 352 240S366.3 208 384 208 416 222.3 416 240 401.7 272 384 272z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/comment-dots.js
// module id = bEwN
// module chunks = 0